import SectionContainer from '@/app/components/SectionContainer';

import { JobCategoryButton } from './JobCategoryButton/JobCategoryButton';
import styles from './JobsSection.module.scss';
import anaesthetics from './assets/anaesthetics.jpg';
import emergencyMedicine from './assets/emergencyMedicine.jpg';
import generalMedicine from './assets/generalMedicine.jpg';
import gp from './assets/gp.jpg';
import intensiveCare from './assets/intensiveCare.jpg';
import obstetrics from './assets/obstetrics.jpg';
import paediatrics from './assets/paediatrics.jpg';
import psychiatry from './assets/psychiatry.jpg';
import surgery from './assets/surgery.jpg';

const jobButtons = [
  { title: 'Emergency Medicine', url: '/doctors/ed-doctors-jobs', imageSrc: emergencyMedicine },
  {
    title: 'General Medicine',
    url: 'doctors/general-medicine-doctor-jobs',
    imageSrc: generalMedicine,
  },
  { title: 'Psychiatry', url: 'doctors/psychiatry-doctor-jobs', imageSrc: psychiatry },
  { title: 'Intensive Care', url: 'doctors/icu-consultant-jobs', imageSrc: intensiveCare },
  { title: 'Surgery', url: 'doctors/surgeon-doctor-jobs', imageSrc: surgery },
  { title: 'Anaesthetics', url: 'doctors/anaesthetics-doctor-jobs', imageSrc: anaesthetics },
  { title: 'Paediatrics', url: 'doctors/paediatrics-doctor-jobs', imageSrc: paediatrics },
  {
    title: 'Obstetrics and Gynaecology',
    url: 'doctors/obstetrics-and-gynaecology-jobs',
    imageSrc: obstetrics,
  },
  { title: 'GP', url: 'doctors/gp-jobs', imageSrc: gp },
];

export const JobsSection = () => (
  <SectionContainer className={styles.jobsSectionContainer}>
    <div>
      <h3 className={styles.jobsSectionTitle}>
        Explore the <span>largest network of doctor jobs </span>in Australasia
      </h3>
    </div>

    <div className={styles.jobsGrid}>
      {jobButtons.map(job => (
        <JobCategoryButton key={job.title} {...job} />
      ))}
    </div>
  </SectionContainer>
);
